import { DBFindOneCaseInsensitive } from '@weblite/persist'
import { User } from '@weblite/ts-action/user'
import { createStorage } from '../lib/storage'

const collection = 'users'
const [storage, usersReducer] = createStorage<User>(collection)

const findByUsername = (username: string) => {
  return DBFindOneCaseInsensitive(
    collection,
    username,
    'username',
  ) as Promise<User>
}

const findByPhone = (phone: string) =>
  DBFindOne(collection, phone, 'phone') as Promise<User | undefined>

const usersStorage = { ...storage, findByUsername, findByPhone }

export { usersStorage, usersReducer }
